<template>
  <closable-card :title="'Conditions générales de vente'">

    <span>
      Learn and Watch édite et met à disposition une plateforme d’apprentissage de l’anglais grâce à des quiz de vocabulaire anglais par épisode de série anglophone. La plateforme est disponible sur ordinateur, sur tablette et sur mobile.
      <br>Les présentes Conditions Générales de Vente (nommé CGV) définissent les conditions de Commande et de livraison de l’accès à la partie Premium de la plateforme à l’Utilisateur, pour permettre aux Utilisateurs d’utiliser les services Premium.
      <br>Elles sont conclues entre LUDOCEO SAS et l’Utilisateur.
      <br>Les CGV sont complétées par les CGU de la plateforme. Les CGV sont de valeur supérieure aux CGU. Les CGV peuvent donc y déroger.
    </span>

    <h2>1. Définitions</h2>

    <span>
      Dans la suite des présentes CGV et de tout autre document contractuel qui s’y rattache, les termes dont la première lettre figure en majuscule auront la signification suivante au singulier et au pluriel :
    </span>
    <ul>
      <li>
        « la Plateforme » : Les services Learn and Watch sur ordinateur, tablette ou mobile via une application, éditée par Learn and Watch. Elle peut être utilisée sur divers terminaux et en format web-app à l’adresse suivante : www.learnandwatch.com .
      </li>
      <li>« CGU » les conditions générales d’utilisation de la Plateforme.</li>
      <li>« CGV » : les présentes conditions générales de vente de la Plateforme par Learn and Watch.</li>
      <li>« Compte » : le Compte de l’Utilisateur sur le site www.learnandwatch.com, lui permettant d’avoir accès aux services proposés par Learn and Watch, accessible par son identifiant ainsi que son mot de passe, et contenant ses informations personnelles ainsi que son historique.</li>
      <li>« Abonnement » : l’accès aux services payants de la Plateforme </li>
      <li>« Commande », « Commander » : tout acte de commande d’abonnement premium auprès de Learn and Watch.</li>
      <li>« Données Personnelles » : les données personnelles collectées et traitées par Learn and Watch.</li>
      <li>« Learn and Watch » : LUDOCEO SAS, société par actions simplifiée, au capital de 2000 euros, dont le siège social est situé au 3, Boulevard Edouard Rey, 38000 GRENOBLE (France), immatriculée au Registre du Commerce et des Sociétés de GRENOBLE sous le numéro SIREN 885 318 642, représentée par Monsieur Romain DESTENAY, Président.</li>
      <li>« Partie » : Learn and Watch et/ou l’Utilisateur</li>
      <li>« Politique de Confidentialité » : la politique de confidentialité, qui détaille les conditions applicables à la collecte et au traitement des Données Personnelles par Learn and Watch, accessible au sein de la Plateforme.
      </li>
      <li>« Utilisateur » : l’utilisateur de la Plateforme</li>
    </ul>

    <h2>2. Acceptation et modification des CGV</h2>
    <h3>2.1. Cadre des CGV</h3>

    <span>Les CGV s’appliquent à toute Commande d’abonnement de la Plateforme auprès de Learn and Watch.</span>

    <h3>2.2. Acceptation des CGV</h3>
    <span>Pour Commander des abonnements de la Plateforme, l’Utilisateurs doit lire et accepter les CGV.

<br>Cette acceptation sera exprimée en validant le bouton d’acceptation des CGV lors de la Commande, ou en cochant la case à cet effet.
</span>

    <h2>3. Commande</h2>
    <h3>3.1. Modalités de Commande</h3>

    <span>Les étapes de la Commande sont les suivantes :</span>
    <ul>
      <li>Création d’un Compte par l’Utilisateur s’il s’agit d’une première Commande ou connexion à son Compte s’il existe déjà</li>
      <li>Choix de l’abonnement que l’Utilisateur souhaite Commander</li>
      <li>Prise de connaissance et validation des CGV par l’Utilisateur</li>
      <li>Fourniture des informations d’identification de l’Utilisateur</li>
      <li>Fourniture des informations de paiement de la Commande par l’Utilisateur</li>
      <li>Visualisation du résumé de la Commande pour validation finale</li>
      <li>Validation de la Commande par l’Utilisateur</li>
      <li>Traitement du paiement par Paddle le prestataire de paiement de Learn and Watch.
      </li>
      <li>Envoi d’un mail de confirmation de Commande à l’Utilisateur par Learn and Watch.</li>
    </ul>

    <span>Toute Commande n’est constituée que si Learn and Watch envoie un email de confirmation de Commande à l’Utilisateur.

<br>Les informations de Commande fournies par l’Utilisateur devront être à jour et réelles.
</span>

    <h3>3.2. Erreurs de Commande</h3>
<span>Learn and Watch ne saurait en aucun cas être responsable d’erreurs de saisie par l’Utilisateur lors de la Commande, ni de leurs éventuelles conséquences.

<br>Learn and Watch ne sera tenu d’aucune obligation d’accepter une annulation ou modification sans frais de la commande en cas d’erreur.

<br>Toute Commande passée est intégralement due.
</span>

    <h3>3.3. Refus de Commande</h3>
    <span>Learn and Watch se réserve le droit de refuser toute commande pour motif légitime, notamment en cas de problèmes de paiement, problèmes suite à la fourniture d’informations incomplètes et/ou imprécises par l’Utilisateur, de montant de Commande anormalement élevé ou de Commande passée de mauvaise foi.</span>

    <h2>4. Livraison</h2>
    <span>Lors de la livraison, Learn and Watch fournira à l’Utilisateur la dernière version de la Plateforme, telle que commercialisée à la date de commande, ainsi que l’accès au back-office de l’Application.

<br>La Plateforme sera livrée électroniquement via le compte membre existant de l’Utilisateur ainsi que par email.

<br>L’Utilisateur est responsable de s’assurer qu’il disposera des moyens permettant l’accès à la Plateforme (connexion internet, ordinateur, électricité … ) ainsi que du matériel nécessaire au bon fonctionnement de la Plateforme et du service (abonnement aux différents distributeurs de vidéo ou  accès aux séries travaillés avec Learn and Watch)
<br>En cas de difficulté de téléchargement, l’Utilisateur est invité à contacter Learn and Watch à l’adresse email : contact@learnandwatch.com et Learn and Watch proposera dans la mesure du possible une solution de contournement.

<br>Après réception du paiement par Learn and Watch, l’Utilisateur verra augmenter immédiatement les capacités d’utilisateurs et de contenu conformément à l’abonnement souscrit.
</span>

    <h2>5. Maintenance</h2>
    <span>Learn and Watch fournit également la garantie légale de conformité et contre les vices cachés. Learn and Watch s’engage uniquement à corriger les bugs de la Plateforme. Aucune maintenance autre que corrective, en application de ces garanties légales, n’est souscrite au titre des présentes CGV.

<br>Learn and Watch ne s’engage en aucune façon au maintien d’un niveau de service  de la Plateforme.

<br>Learn and Watch s’engage uniquement, au titre d’une obligation de moyens, aux élément suivants :
</span>

    <ul>
      <li>Learn and Watch fera ses meilleurs efforts pour garantir une disponibilité  de la Plateforme de 98% par an.</li>
      <li>Dans la mesure du possible, chaque maintenance prévue qui entraîne une interruption du service de plus de cinq minutes est effectuée entre 22h30 et 10h00.</li>
      <li>Les bugs reportés seront corrigés dans les meilleurs délais.</li>
    </ul>

    <span>L’Utilisateur accepte que les services d’installation, de mise en service, de maintenance autre que corrective susvisée, ainsi que les formations, le support technique, les interventions techniques, y compris la correction ou modification de données, ne sont pas compris à la Commande.

<br>Si l’Utilisateur souhaite bénéficier de ces prestations, celles-ci sont à souscrire spécifiquement auprès de Learn and Watch et seront facturées de manière complémentaire.

<br>Learn and Watch est libre de modifier les fonctions de la Plateforme, y compris d’ajouter, de modifier, d’améliorer ou de supprimer des fonctions sans que cela n’engage sa responsabilité.
</span>

    <h2>6. Réversibilité</h2>
    <h3>6.1. Droit de rétractation (Europe)</h3>
    <span>Conformément à l'article L. 121-21 du Code de la consommation et à la Directive 2011/83/UE du Parlement européen et du Conseil relative aux droits des consommateurs, toute souscription à un Abonnement pourra être remboursée sans pénalité sur simple demande non motivée dans un délai de 14 jours à compter de ladite souscription par l'envoi d'un courrier contenant un RIB du compte bancaire utilisé adressé à :

<br>Learn and Watch, 3 Boulevard Edouard Rey, 38000 Grenoble (France)

<br>Il ne sera procédé qu'à un seul remboursement par RIB et par compte d’Utilisateur.

<br>A réception de l'ensemble de ces documents, l'Utilisateur sera remboursé de l'intégralité des sommes versées au Site dans un délai de 14 jours à compter de la réception du courrier. Il est rappelé qu’en application des dispositions de l'article Article L121-21-8 du Code de la Consommation et à l’article 16 de la Directive 2011/83/UE du Parlement européen et du Conseil, l'Utilisateur ne pourra plus exercer son droit de rétractation après utilisation des Services (payants et/ou gratuits).
</span>

    <h3>6.2. Droit de rétractation (Non Europe)</h3>
    <span>Conformément au Code de la consommation relative aux droits des consommateurs, toute souscription à un Abonnement pourra être remboursée sans pénalité sur simple demande non motivée dans un délai de 14 jours à compter de ladite souscription par l'envoi d'un courrier contenant un RIB du compte bancaire utilisé adressé à :

<br>Learn and Watch, 3 Boulevard Edouard Rey, 38000 Grenoble

<br>Il ne sera procédé qu'à un seul remboursement par RIB et par Compte d’Utilisateur.

<br>A réception de l'ensemble de ces documents, l'Utilisateur sera remboursé de l'intégralité des sommes versées au Site dans un délai de 14 jours à compter de la réception du courrier. Il est rappelé qu’en application des dispositions du Code de la Consommation, l'Utilisateur ne pourra plus exercer son droit de rétractation après utilisation des Services (payants et/ou gratuits).
</span>

    <h2>7. Modalités financières</h2>
    <h3>7.1. Prix</h3>
    <span>Abonnements et Conditions de paiement
<br>Learn and Watch des services payants (“Premium”)
<br>Ces services premium sont disponibles sur Learn and Watch à titre d’abonnements.
<br>La conclusion du contrat prend effet lors de validation du paiement du service.
<br>Les prix, la durée, le type de facturation et les services accessibles sont définis sur les pages du site récapitulants les offres disponibles. Ils sont définis en Euros et TTC (toutes charges comprises)
<br>Les contrats d’offres d’abonnements sont conclus pour la durée spécifiée dans la commande. La rémunération pour la durée est payable à la conclusion du contrat. A la fin de chaque durée initiale d’abonnement, le contrat est renouvelé automatiquement sur la même base tarifaire et selon des périodicités identiques.
<br>Le montant de l’abonnement sera facturé le premier jour de chaque durée de reconduction.
<br>L’Utilisateur a la possibilité de stopper à tout moment, et au plus tard 24 heures avant la date d’expiration de l’abonnement en cours, le renouvellement automatique de son abonnement en se rendant sur la page de gestion de son compte Learn and Watch puis en cliquant sur le lien approprié dans la rubrique « Premium ».
<br>Notez que cette procédure n'emporte pas le remboursement de la période à courir jusqu'à l'échéance de l'abonnement.
<br>L’Utilisateur aura accès à son Compte Premium jusqu’à la fin de la période d’abonnement en cours et aucun remboursement des périodes déjà achetées sera effectué.
<br>L’Utilisateur est le seul responsable du paiement par carte bancaire ou du prélèvement sur compte bancaire pour le service proposé. Learn and Watch n'est pas responsable des problèmes de paiement liés au fonctionnement du service de commerce électronique.
<br>Les factures sont envoyées par email à l’Utilisateur dès la souscription et un accès est disponible sur son Compte Utilisateur.
<br>Le paiement est effectué net et sans escompte.
</span>

    <h3>7.2. Transactions</h3>
    <span>Learn and Watch fournit un système de paiement sécurisé, proposé par un prestataire spécialisé respectant les lois et normes applicables à son activité.

<br>Ce prestataire est le suivant : Paddle

<br>En passant une Commande, l’Utilisateur accepte les conditions générales de ce prestataire.

<br>En cas d’une impossibilité de débiter les sommes dues en règlement de la Commande, pour quelque raison que ce soit, la Commande ne sera pas constituée et pas transmise.

<br>Learn and Watch n’a accès à aucune donnée relative aux moyens de paiement de l’Utilisateur, à l’exception des quatre derniers chiffres de sa carte bancaire.
</span>

    <h3>7.3. Retard ou absence de paiement
    </h3>
    <span>En cas de retard de paiement, Learn and Watch peut suspendre l’accès aux services payants de la Plateforme et/ou résilier l’abonnement, sans préavis et sans engager sa responsabilité. Toute somme due au titre d’une période Commandée restera due.</span>

    <h3>7.4. Archivage</h3>
    <span>Learn and Watch archivera les transactions et les factures sur un support fiable et durable constituant une copie fidèle. Les registres informatisés seront considérés par les Parties comme preuve des communications, paiements et transactions intervenus entre les Parties.</span>

    <h2>8. Contact</h2>
    <span>L’Utilisateur peut contacter Learn and Watch à l’adresse suivante : contact@learnandwatch.com</span>

    <h2>9. Obligations des Parties</h2>
    <h3>9.1. Obligations de Learn and Watch</h3>
    <span>Learn and Watch s’engage à fournir l’accès aux services payants dans les délais convenus aux CGV.

<br>Aucun autre engagement n’est convenu au titre des présentes.
</span>

    <h3>9.2. Obligations de l’Utilisateur</h3>
    <span>L’Utilisateur s’engage à régler toutes les sommes dues au titre de la Commande.

<br>L’Utilisateur s’engage à respecter les présentes CGV et CGU.
</span>

    <h2>10. Responsabilité</h2>
    <span>La responsabilité de Learn and Watch est strictement limitée à la livraison des services payants de la Plateforme, en cas d’abonnement.

<br>Learn and Watch n’engage pas sa responsabilité au titre de la mise à disposition, de la disponibilité, de la maintenance et de l’utilisation de la Plateforme. Aucune garantie expresse ou implicite n’est fournie au titre de la qualité de la Plateforme. L’Utilisateur, des informations qui y figurent, et leur adéquation aux besoins de l’Utilisateur. L’Utilisateur est responsable de s’assurer que la Plateforme correspond à ses besoins.

<br>Learn and Watch fournit une Plateforme conforme à ses spécifications telles qu’exprimées sur le site www.learnandwatch.com à date de la Commande. Il est toutefois entendu que la Plateforme est susceptible d’évoluer et donc que des variations à la marge peuvent exister par rapport aux spécifications présentées sur le site www.learnandwatch.com, ce que l’Utilisateur accepte.

<br>Learn and Watch ne fournit aucune autre prestation.
</span>

    <h2>11. Clauses générales</h2>
    <h3>11.1. Respect de la législation</h3>
    <span>L’Utilisateur doit prendre connaissance des lois locales et nationales afin de s’assurer qu’il peut utiliser la Plateforme.</span>

    <h3>11.2. Intégralité de l’accord</h3>
    <span>Les présentes CGV prévalent sur toute autre stipulation potentiellement applicable à la relation entre Learn and Watch et l’Utilisateur. Les présentes CGV annulent et remplacent tout engagement antérieur des Parties relatif à l’objet et constituent l’intégralité de l’accord entre les Parties eu égard à l’objet des présentes.</span>

    <h3>11.3. Exclusivité</h3>
    <span>Aucune exclusivité n’est conclue entre les Parties par l’acceptation des présentes CGV. Les Parties restent libres de contracter avec les tiers de leur choix.</span>

    <h3>11.4. Survie de certaines stipulations</h3>
    <span>La fin des présentes CGV, pour quelque cause que ce soit, ne saurait valoir terme pour les clauses dont la nature ou le contenu nécessite leur maintien.</span>

    <h3>11.5. Non-validité partielle</h3>
    <span>Si une ou plusieurs stipulations des présentes CGV sont tenues pour non valides ou déclarées comme telles en application d’une loi, d’un règlement ou à la suite d’une décision définitive d’une juridiction compétente, elles seront réputées non-écrites les autres stipulations garderont toute leur force et leur portée.</span>

    <h3>11.6. Non-renonciation et tolérance</h3>
    <span>Le fait pour Learn and Watch de ne pas se prévaloir auprès de l’Utilisateur d’un manquement à l’une quelconque des obligations visées au sein des présentes CGV ne saurait être interprété pour l’avenir comme une renonciation à l’obligation en cause et n’a pas pour effet d’accorder des droits acquis à l’Utilisateur.

<br>Un défaut ou un retard dans l’exercice d’un droit par Learn and Watch ne peut être interprété comme une renonciation à ce droit.
</span>

    <h3>11.7. Indépendance</h3>
    <span>Aucune des Parties ne peut prendre un engagement au nom et/ou pour le compte de l’autre. En outre, chacune des Parties demeure seule responsable de ses actes, allégations, engagements, service, produits et personnels.</span>

    <h3>11.8. Preuve</h3>
    <span>Les Parties acceptent que l’ensemble des communications électroniques, notamment courriel, fasse preuve entre elles.

<br>L’Utilisateur reconnaît notamment la valeur de preuve des systèmes d’enregistrement automatique de Learn and Watch, et notamment de la Plateforme, sauf pour lui d’apporter une preuve contraire, l’Utilisateur renonce à les contester en cas de litige.
</span>

    <h3>11.9. Force majeure</h3>
    <span>Dans le cadre de l’exécution des présentes CGV, Learn and Watch ne sera pas tenue pour responsable si le service ne fonctionne plus en raison de tout événement de force majeure.

<br>Pour les besoins des présentes CGV, la force majeure s’entend comme tout évènement imprévisible, irrésistible et extérieur aux Parties au sens du droit et de la jurisprudence française.

<br>En cas de survenance d’un cas de force majeure, Learn and Watch fera ses meilleurs efforts pour remplir ses obligations.

<br>Si la force majeure subsiste, Learn and Watch pourra résilier les CGV et annuler toute Commande, par notification écrite et sans préavis.
</span>

    <h3>11.10. Juridiction compétente</h3>
    <span>Tout litige relatif à l’exécution ou l’interprétation des présentes CGV, non résolu à l’amiable entre les Parties, sera soumis au Tribunal compétent du siège de Learn and Watch, y compris en matière de référé, d’un appel en garantie ou d’une pluralité de défendeurs, et quel que soit le pays d’origine de l’Utilisateur.</span>

  </closable-card>

</template>

<script>

import {mapGetters} from "vuex";

export default {
  name: "cgv",
  components: {closableCard: () => import(/* webpackPrefetch: true */ '@/components/closableCard.vue')},
  computed: {
    ...mapGetters('global', [
      'isMobile',
    ]),
  },
}
</script>

<style scoped>
h2 {
  margin-top: 1vw;
}

.approche {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-content: flex-start;
}

.equipe {
  display: grid;
  grid-template-columns: auto  1fr;
  grid-template-rows: auto auto;
  grid-column-gap: 5vw;
  align-items: flex-start;
  justify-items: flex-start;
}

.profile_pic {
  width: 75px;
  height: 75px;
  border-radius: 10px;
  background-size: cover;
}

.role {
  margin-bottom: 25px;
}

.logoTVDB {
  height: 40px;
}

.logoOpenSub {
  height: 40px;
}
</style>